/**
 * This method check given object and remove empty conditions. When all conditions are empty, then we return null
 * @param {object|null} requiredWhen
 */
export const removeEmptyConditions = requiredWhen => {
  if (!requiredWhen) {
    return requiredWhen;
  }

  const oldConditions = requiredWhen.conditions || [];

  const conditions = oldConditions.filter(
    c => c.variableName || removeEmptyConditions(c),
  );

  if (conditions.length === 0) {
    return null;
  }

  return {
    conditions,
    logicalOperator: requiredWhen.logicalOperator,
  };
};
